import { Component } from 'react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'

const DEFAULT_COLOR = '#767676'

// Keep dimensions in em so `size` scales the box and check together.
const Box = styled.div`
  display: flex;
  justify-content: center;
  cursor: pointer;
  font-size: ${p => p.size ?? '1.5rem'};
  height: 1em;
  width: 1em;
  border: 3px solid ${p => p.color ?? DEFAULT_COLOR};
  border-radius: 4px;
  background-color: ${p => (p.checked ? (p.color ?? DEFAULT_COLOR) : 'white')};
  transition: background-color 0.3s;
`

const Check = styled.div`
  width: 0.3em;
  height: 0.6em;
  border-right: 2px solid white;
  border-bottom: 2px solid white;
  transform: ${p => (p.checked ? 'rotate(45deg)' : 'scale(0.6) rotate(45deg)')};
  transition: transform 0.2s;
`

class Checkbox extends Component {
  static propTypes = {
    checked: PropTypes.bool,
    color: PropTypes.string,
    size: PropTypes.string,
  }

  render() {
    return (
      <Box {...this.props}>
        <Check checked={this.props.checked} />
      </Box>
    )
  }
}

export default Checkbox
